(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-clothing-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('filter:update', (event) => {
 if (typeof event.shouldShowClearAll !== 'function') return;
 const hidden = event.shouldShowClearAll();
 for (const node of document.querySelectorAll('.arc-clothing-hub__brands,.arc-clothing-hub>h2,.arc-home-products:has(+ .arc-clothing-hub__catalog),.arc-clothing-hub__catalog')) {
  node.toggleAttribute('hidden', hidden);
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-home-confidence"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('arc-home-confidence')) {
  customElements.define(
    'arc-home-confidence',
    class extends HTMLElement {

      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.track = this.querySelector(
          '.arc-home-confidence__inner'
        );

        this.viewport = this.querySelector(
          '.arc-home-confidence__viewport'
        );

        if (!this.track || !this.viewport) return;

        // Poista mahdolliset vanhat kopiot.
        this.track
          .querySelectorAll('[data-clone]')
          .forEach(item => item.remove());

        this.items = Array.from(this.track.children);

        this.mobile = matchMedia(
          '(max-width: 549px)'
        );

        this.reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.visible = false;
        this.lastTravel = null;
        this.lastDuration = null;

        // Staattisen vaihtumisen asetukset.
        this.activeIndex = 0;
        this.rotationTimer = null;
        this.rotationDelay = 5000;

        this.toggleAttribute(
          'data-single',
          this.items.length < 2
        );

        // Merkitse ensimmäinen aktiiviseksi.
        this.showActiveItem();

        // Luo kopiot jatkuvaa vieritystä varten.
        if (this.items.length > 1) {
          this.items.forEach(item => {
            const clone = item.cloneNode(true);

            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;

            clone.removeAttribute('data-active');
            clone.removeAttribute('data-shopify-editor-block');
            clone.removeAttribute('id');

            this.track.append(clone);
          });
        }

        // Reagoi mobiilinäkymän muutoksiin.
        this.mobile.addEventListener(
          'change',
          () => this.measure(),
          { signal }
        );

        // Reagoi liikkeen vähentämisen muutoksiin.
        this.reduced.addEventListener(
          'change',
          () => this.measure(),
          { signal }
        );

        // Pysäytä toiminta taustavälilehdellä.
        document.addEventListener(
          'visibilitychange',
          () => this.sync(),
          { signal }
        );

        // Tarkkaile osion näkyvyyttä.
        this.observer = new IntersectionObserver(
          entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          }
        );

        this.observer.observe(this);

        // Tarkkaile koon muuttumista.
        this.resize = new ResizeObserver(() => {
          this.measure();
        });

        this.resize.observe(this.viewport);

        // Odota fonttien latautumista.
        document.fonts.ready.then(() => {
          if (this.isConnected) {
            this.measure();
          }
        });

        this.measure();
      }

      disconnectedCallback() {
        this.stopRotation();

        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
      }

      /*
        Näytä yksi aktiivinen etu.

        Kaikki muut edut piilotetaan CSS:n
        reduced-motion-tilassa.
      */

      showActiveItem() {
        if (!this.items || !this.items.length) return;

        this.items.forEach((item, index) => {
          const active = index === this.activeIndex;

          item.toggleAttribute('data-active', active);

          // Piilota ei-aktiiviset edut
          // ruudunlukijoilta vain reduced-tilassa.
          if (this.mobile.matches && this.reduced.matches) {
            if (active) {
              item.removeAttribute('aria-hidden');
            } else {
              item.setAttribute('aria-hidden', 'true');
            }
          } else {
            item.removeAttribute('aria-hidden');
          }
        });
      }

      /*
        Vaihda seuraavaan etuun ilman animaatiota.
      */

      nextItem() {
        if (!this.items || this.items.length < 2) return;

        this.activeIndex =
          (this.activeIndex + 1) % this.items.length;

        this.showActiveItem();
      }

      /*
        Käynnistä automaattinen vaihtuminen.
        Vaihtoväli on 5000 ms eli 5 sekuntia.
      */

      startRotation() {
        if (this.rotationTimer !== null) return;
        if (this.items.length < 2) return;

        this.showActiveItem();

        this.rotationTimer = setInterval(() => {
          this.nextItem();
        }, this.rotationDelay);
      }

      /*
        Pysäytä automaattinen vaihtuminen.
      */

      stopRotation() {
        if (this.rotationTimer !== null) {
          clearInterval(this.rotationTimer);
          this.rotationTimer = null;
        }
      }

      /*
        Mittaa jatkuvan vierityksen pituus
        normaalissa mobiilitilassa.
      */

      measure() {
        if (!this.track || !this.items.length) return;

        const firstClone = this.track.querySelector(
          '[data-clone]'
        );

        const shouldAnimate =
          this.mobile.matches &&
          !this.reduced.matches &&
          firstClone &&
          this.items[0];

        // Reduced motion tai työpöytänäkymä.
        if (!shouldAnimate) {
          this.removeAttribute('data-ready');

          this.lastTravel = null;
          this.lastDuration = null;

          this.sync();
          return;
        }

        // Etäisyys alkuperäisestä ensimmäiseen kopioon.
        const travel =
          firstClone.offsetLeft -
          this.items[0].offsetLeft;

        if (!Number.isFinite(travel) || travel <= 0) {
          this.removeAttribute('data-ready');
          this.sync();
          return;
        }

        const duration = Math.max(20, travel / 30);

        const hasChanged =
          this.lastTravel !== travel ||
          this.lastDuration !== duration;

        if (hasChanged || !this.hasAttribute('data-ready')) {

          this.style.setProperty(
            '--arc-benefit-travel',
            `${travel}px`
          );

          this.style.setProperty(
            '--arc-benefit-duration',
            `${duration}s`
          );

          this.lastTravel = travel;
          this.lastDuration = duration;

          this.setAttribute('data-ready', '');
        }

        this.sync();
      }

      /*
        Hallitse molempien toimintatilojen
        käynnistymistä ja pysähtymistä.
      */

      sync() {
        const isVisible =
          this.visible && !document.hidden;

        const useStaticRotation =
          this.mobile.matches &&
          this.reduced.matches;

        // Normaali vieritysanimaatio.
        this.toggleAttribute(
          'data-paused',
          !isVisible
        );

        // Päivitä aktiivisen kohdan näkyvyys.
        this.showActiveItem();

        // Reduced motion: vaihda 5 sekunnin välein.
        if (useStaticRotation && isVisible) {
          this.startRotation();
        } else {
          this.stopRotation();
        }
      }
    }
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-product-explore"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arc-product-explore'))customElements.define('arc-product-explore',class extends HTMLElement{
 connectedCallback(){
  this.refresh=()=>{
   const used=new Set(Array.from(document.querySelectorAll('arc-product-discovery .arc-discovery__track [data-product-handle]')).map(e=>e.dataset.productHandle));
   let shown=0;
   for(const card of this.querySelectorAll('.arc-explore__card')){card.hidden=used.has(card.dataset.handle)||shown>=8;if(!card.hidden)shown++;}
   const grid=this.querySelector('[data-explore-products]');if(grid)grid.hidden=shown===0;
  };
  this.refresh();this.observer=new MutationObserver(this.refresh);
  for(const track of document.querySelectorAll('arc-product-discovery .arc-discovery__track'))this.observer.observe(track,{childList:true});
 }
 disconnectedCallback(){this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
